/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FreelancingExperience } from './';
import {
    FreelancingExperienceFromJSON,
    FreelancingExperienceFromJSONTyped,
    FreelancingExperienceToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateFreelancingExperienceRequest
 */
export interface UpdateFreelancingExperienceRequest {
    /**
     * 
     * @type {FreelancingExperience}
     * @memberof UpdateFreelancingExperienceRequest
     */
    freelancingExperience: FreelancingExperience;
}

/**
 * Check if a given object implements the UpdateFreelancingExperienceRequest interface.
 */
export function instanceOfUpdateFreelancingExperienceRequest(value: object): value is UpdateFreelancingExperienceRequest {
    if (!('freelancingExperience' in value) || value['freelancingExperience'] === undefined) return false;
    return true;
}

export function UpdateFreelancingExperienceRequestFromJSON(json: any): UpdateFreelancingExperienceRequest {
    return UpdateFreelancingExperienceRequestFromJSONTyped(json, false);
}

export function UpdateFreelancingExperienceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFreelancingExperienceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'freelancingExperience': FreelancingExperienceFromJSON(json['freelancingExperience']),
    };
}

export function UpdateFreelancingExperienceRequestToJSON(value?: UpdateFreelancingExperienceRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'freelancingExperience': FreelancingExperienceToJSON(value['freelancingExperience']),
    };
}

